/**
 * Share.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Card, PageWrap } from '@minerva-analytics/pantheon';

import ShareButtons from 'components/ShareButtons';
import CardHeader from 'components/CardHeader';
import CardBody from 'components/CardBody';

import authedUser from 'store/user/selectors/authedUser';

import alertActions from 'store/alert/actions';
import { CLOUDFRONT_URL } from 'utils';

import { ShareHeadline, ShareImage, ShareText, ShareShareText } from './Share.styles';

/**
 * The page that will hold the buttons for sharing
 *
 */
export class Share extends Component {
  static propTypes = {
    user: PropTypes.object,
    createAlert: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { user, createAlert } = this.props;

    return (
      <PageWrap>
        <Helmet>
          <meta property="og:title" content="Share QuizHive" />
          <meta name="description" property="og:description" content="Want to share QuizHive with your friends? Its more fun with more people!" />
        </Helmet>
        <Card size="medium">
          <CardHeader>
            Share QuizHive
          </CardHeader>
          <CardBody>
            <ShareHeadline>
              Share QuizHive with Friends
            </ShareHeadline>
            <ShareImage
              src={ `${CLOUDFRONT_URL}/qh_main_sharing.jpeg` }
              alt="QuizHive Sharing Image"
            />
            <ShareText>
              Connecting and competing with friends is the best way
              to enjoy QuizHive. Whoever you invite will show up on
              your friend leaderboard and you will be able to see how
              they are doing.
            </ShareText>
            <ShareShareText>
              Share QuizHive with friends and grow your friends leaderboard!
            </ShareShareText>
            <ShareButtons
              user={ user }
              source="share-page"
              twitterText="I love #trivia. This site IS trivia #quizhive."
              fbText="Check out this trivia website I found. I love trivia!"
              emailText={ `Quizhive is a trivia website where you can see how you rank against your friends in more that 20 different quizzes. Come challenge me!\n\nThis site IS trivia:` }
              createAlert={ createAlert }
            />
          </CardBody>
        </Card>
      </PageWrap>
    );
  }
}

export default connect((state) => {
  return {
    user: authedUser(state),
  };
}, {
  createAlert: alertActions.createAlert,
})(Share);
